import serviceBase from '../../../../Services/serviceBase'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'

class NotificationsActions {
  
  getNotifications = async (payload) => {
    let url = `${
      window._env_.COMMUNITY_API_URL || 'https://communityapi-qa.iartest.com/api/v1'
    }/notifications/getNotifications`
    return serviceBase.post(url, payload).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  deleteNotifications = async (ids, iarMember) => {
    let url = `${
      window._env_.COMMUNITY_API_URL || 'https://communityapi-qa.iartest.com/api/v1'
    }/notifications/deleteNotifications`

    return serviceBase.post(url, ids, {
      deleteBy: iarMember
    }).then(
      (response) => {
        return response.status === 200
      }
    )
  }
}

export default new NotificationsActions()
